"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavItemAccordion = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("../../icons");
// could be collapsed and active if a child NavLink is active
var NavItemAccordion = function (_a) {
    var active = _a.active, children = _a.children, Icon = _a.Icon, open = _a.open, title = _a.title;
    var _b = (0, react_1.useState)(open), isOpen = _b[0], setIsOpen = _b[1];
    var toggle = function () { return setIsOpen(!isOpen); };
    var Arrow = isOpen ? icons_1.Up24 : icons_1.Down24;
    return ((0, jsx_runtime_1.jsxs)(reactstrap_1.NavItem, __assign({ className: (0, classnames_1.default)(Icon && 'nav-item-icon') }, { children: [(0, jsx_runtime_1.jsx)(reactstrap_1.NavLink, __assign({ href: "#", className: "nav-link-accordion", onClick: toggle, active: active }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [Icon && (0, jsx_runtime_1.jsx)(Icon, { className: "nav-link-icon", "data-testid": "nav-item-accordion-prefix" }), title, (0, jsx_runtime_1.jsx)(Arrow, { "data-testid": isOpen ? 'icon-arrow-up' : 'icon-arrow-down', className: (0, classnames_1.default)('nav-link-icon ms-auto') })] }) })), (0, jsx_runtime_1.jsx)(reactstrap_1.Collapse, __assign({ isOpen: isOpen }, { children: children }))] })));
};
exports.NavItemAccordion = NavItemAccordion;
